import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import projectCardImage from '../../../assets/images/home/projectCardImage/projectCardImage.png';
import { useNavigate } from 'react-router-dom';

const ProjectsHeroCard = () => {
    const navigate = useNavigate();

    return (
        <div className="projects-hero-card">
            <div className="projects-hero-contents">
                <div className="projects-hero-image-container">
                    <LazyLoadImage
                        draggable={false}
                        src={projectCardImage}
                        alt="Construction site"
                        effect="blur"
                        width="100%"
                        height="100%"
                        style={{ objectFit: 'cover' }}
                    />
                </div>
                <div className="projects-hero-description">
                    <h1>VISION TO REALITY</h1>
                    <p>
                        Discover our wide range of projects, from unique residential spaces to major commercial and industrial builds. With a focus on quality, durability, and excellence, our team brings ideas to life, ensuring precision and efficiency at every stage.
                    </p>
                    <button
                        className="projects-hero-learn-more-button"
                        onClick={() => {
                            navigate('/Projects');
                            window.scrollTo({ top: 0 });
                        }}
                        aria-label="Learn more about us"
                    >
                        Ongoing / Completed Projects
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProjectsHeroCard;